export default __webpack_public_path__ + "static/media/MightyMagnets_04.5dff4ebd.png";